module.exports = __webpack_public_path__ + "media/images/emblems/Cartigny-coat_of_arms-5aec733eb9f1aed11a6734c69d0895be.svg";